import React from "react";
import { alpha, Box, Paper, Stack, Typography } from "@mui/material";
import TimelineRoundedIcon from "@mui/icons-material/TimelineRounded";

export default function ProgressStoryCard({ rows = [] }) {
  return (
    <Paper elevation={0} sx={{ borderRadius: "8px", p: 3 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2.25 }}>
        <Box
          sx={{
            width: 40,
            height: 40,
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: alpha("#17345d", 0.08),
            color: "primary.main",
          }}
        >
          <TimelineRoundedIcon fontSize="small" />
        </Box>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Progress story
        </Typography>
      </Box>

      {rows.length ? (
        <Stack spacing={1.25}>
          {rows.map((row) => (
            <Box
              key={row.id}
              sx={{
                borderRadius: "8px",
                border: "1px solid",
                borderColor: "divider",
                px: 1.75,
                py: 1.5,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                bgcolor: row.tone === "active"
                  ? alpha("#17345d", 0.04)
                  : row.tone === "success"
                    ? alpha("#2d8a5f", 0.08)
                    : "#fff",
              }}
            >
              <Typography sx={{ fontSize: 14, fontWeight: 700, color: "text.secondary" }}>
                {row.label}
              </Typography>
              <Typography sx={{ fontSize: 15, fontWeight: 700, color: row.tone === "success" ? "success.dark" : "text.primary" }}>
                {row.value}
              </Typography>
            </Box>
          ))}
        </Stack>
      ) : (
        <Typography sx={{ color: "text.secondary" }}>
          Real progress will appear here after you log progress or complete habits.
        </Typography>
      )}
    </Paper>
  );
}
